module.exports = __webpack_public_path__ + "static/img/certificate3.34266b27.png";